// extracted by mini-css-extract-plugin
export default {"datePicker":"DatePicker_datePicker__FZLPk","datePickerInput":"DatePicker_datePickerInput__nb3-+","requiredAsterisk":"DatePicker_requiredAsterisk__IPHBV"};